module.exports = __webpack_public_path__ + "img/LDEvsCobra.f419b764.png";